import {createFormData} from "./form-data-helper";
import axios from "../../axios-instance";
import {ONE, ZERO} from "../constants";

const addXssInputFiltering = (field) => {
  field.addEventListener('input', (event) => {
    let position = event.target.selectionStart
    const value = event.target.value;
    const re = new RegExp(/[^A-Za-z0-9\s_@.\-~!#$%^&*()+=|/'"]/g);

    if (re.test(value)) {
      event.target.value = value.replace(re, '')
      position--;
    }

    event.target.setSelectionRange(position, position)
  });
};

const saveEntity = (buttonSave, data, entityType) => {
  $(document).trigger(`save_before_send.${entityType}`);
  buttonSave.classList.add('disabled');
  axios
    .post(`/api/v1/object/${entityType}/save`, createFormData(data))
    .then(response => {
      if (response.data['is_error']) {
        $(document).trigger(`save_error.${entityType}`);
        const headerErrorTitle = document.querySelector(`#${entityType}_edit .error_header`);
        headerErrorTitle.classList.remove('invisible');
        showValidationMessages(response.data.errors, entityType);
        buttonSave.classList.remove('disabled');
      } else {
        _object_edit_dlg_destroy(entityType);
      }
      $(document).trigger(`save.${entityType}`);
    })
    .catch();
};

const getUserData = (userFields, entityType) => {
  const userData = {};
  for (let field of userFields) {
    const inputField = document.querySelector(`#${entityType}_edit [name="${field}"]`);
    if (inputField && inputField.type === 'checkbox') {
      userData[field] = inputField.checked ? ONE : ZERO;
    } else if (inputField && inputField.type === 'radio') {
      userData[field] = document.querySelector(`#${entityType}_edit [name="${field}"]:checked`).value;
    }
    else if (inputField?.tagName === 'AXS-SEARCH-SELECT') {
      userData[field] = inputField.querySelector('select').value
    }
    else if (inputField) {
      userData[field] = inputField.value;
    }
  }
  return userData;
}

const clearDialogErrors = (entityType) => {
  const headerErrorTitle = document.querySelector(`#${entityType}_edit .error_header`);
  headerErrorTitle.classList.add('invisible');
  clear_errors(entityType);
}

export {addXssInputFiltering, saveEntity, getUserData, clearDialogErrors};
